import React from 'react'
import { Outlet } from 'react-router-dom'


const RightBlock = () => {

  return (
    <>
      <Outlet />
    </>
  );
};

export default RightBlock;